import React, { useCallback, useState } from 'react';
import { FormTitle } from '../Register/FormTitle/FormTitle';
import { Form } from '../Register/Step/Form';
import { Input } from '../Input/Input';
import { validateEmail, validateFormatEmail } from '../validate';
import { ButtonContainer } from '../Button/Button';
import s from '../Authorization.module.css';
import { BackStepItem } from '../BackStep/BackStepItem';
import { Contacts } from '../Contacts/Contacts';
import { Header } from '../Header/Header';
import { BackLoginLink } from '../BackLoginLink/BackLoginLink';

export const ForgotPassword = () => {
    const subtitle = () => <span>{i18next.t('ForgotPassword.return.subtitle')}</span>;

    const [errors, setErrors] = useState({
        email: null,
    });
    const [email, setEmail] = useState('');
    const [isEmailSent, setIsEmailSent] = useState(false);

    const sendForgotPasswordRequest = useCallback(() => {
        fetch('/resetting/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ username: email }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setErrors((prevState) => ({ ...prevState, email: data.error }));
                }
                if (data.success) {
                    setIsEmailSent(true);
                }
            })
            .catch((err) => {
                window.console.error(`[Reset] ${err}`);
            });
    }, [email]);
    const buttonClick = () => {
        setErrors((prevState) => ({ ...prevState, email: validateEmail(email) }));

        if (errors.email === null) {
            sendForgotPasswordRequest();
        }
    };

    const isButtonDisabled = !email.length > 0;

    return (
        <div className={s.authorizationBlock}>
            <Header type="mobile" backLogin needShowBack />
            <div className={s.content}>
                <div className={s.mainImage} />
                <div className={s.formWrapper}>
                    <div>
                        <Header type="desktop" backLogin needShowBack />
                        <div className={s.forgotPasswordBlock}>
                            {isEmailSent && (
                                <div>
                                    <FormTitle
                                        title={i18next.t(
                                            'ForgotPassword.return.FormTitle.emailSentTitle'
                                        )}
                                        subtitle={i18next.t(
                                            'ForgotPassword.return.FormTitle.emailSentSubtitle'
                                        )}
                                    />
                                    <BackLoginLink />
                                </div>
                            )}
                            {!isEmailSent && (
                                <>
                                    <FormTitle
                                        title={i18next.t('ForgotPassword.return.title')}
                                        subtitle={subtitle()}
                                    />
                                    <Form>
                                        <Input
                                            label={i18next.t(
                                                'ForgotPassword.return.inputEmail.label'
                                            )}
                                            type="email"
                                            error={!!errors.email}
                                            helperText={errors.email ?? ' '}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            onBlur={(e) => {
                                                setErrors((prevState) => ({
                                                    ...prevState,
                                                    email: validateFormatEmail(e.target.value),
                                                }));
                                                setErrors((prevState) => ({
                                                    ...prevState,
                                                    email: validateEmail(e.target.value),
                                                }));
                                            }}
                                            inputProps={{
                                                'data-id': 'authorization-email',
                                            }}
                                        />
                                    </Form>
                                    <ButtonContainer
                                        textButton={i18next.t(
                                            'ForgotPassword.return.ButtonContainer.textButton'
                                        )}
                                        disable={isButtonDisabled}
                                        needShowLoader={false}
                                        onClick={buttonClick}
                                    />
                                    <div className={s.stepBackMobile}>
                                        <a href={`${BASE_URL}/login`}>
                                            <BackStepItem
                                                text={i18next.t('ForgotPassword.return.backStep')}
                                            />
                                        </a>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <Contacts />
                </div>
            </div>
        </div>
    );
};
